import { z } from 'zod';

/**
 * Message templates (wayai#4931): a connection's WhatsApp, email and app templates, served at
 * `/api/message-templates`. WhatsApp templates are what an automation's `send_message` action and
 * a conversation follow-up send outside the 24h window.
 */

// ---------------------------------------------------------------------------
// Template Params & Queries
// ---------------------------------------------------------------------------

export const templateIdParam = z.object({
  id: z.string().uuid(),
});

export const listTemplatesQuery = z.object({
  hub_id: z.string().uuid(),
  connection_id: z.string().uuid(),
});

export const deleteTemplateQuery = z.object({
  hub_id: z.string().uuid(),
  connection_id: z.string().uuid(),
});

export const templateStatusQuery = z.object({
  hub_id: z.string().uuid(),
  connection_id: z.string().uuid(),
});

export const createTemplateBody = z.object({
  hub_id: z.string().uuid(),
  connection_id: z.string().uuid(),
}).passthrough();

export const updateTemplateBody = z.object({}).passthrough();

export const submitTemplateBody = z.object({
  hub_id: z.string().uuid(),
  connection_id: z.string().uuid(),
}).passthrough();

export const testTemplateBody = z.object({
  hub_id: z.string().uuid(),
  connection_id: z.string().uuid(),
}).passthrough();
